export class Role {
    public id: string = "0";
    public name: string;   
    constructor() {}
}